<template>
	<a href="#main-content" class="srt accessibility">Skip to main content</a>
</template>

<script>
export default {
	name: 'Accessibility',
}
</script>
